import * as Yup from 'yup';

export const CompanyValidationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    contact: Yup.string().required("Contact phone number is required"),
    address: Yup.string().required("Address is required")
});
